// extracted by mini-css-extract-plugin
export default {"poster":"index_poster_lmoBN"};